module.exports = __webpack_public_path__ + "static/media/text-part-back.3eaabc2b.png";